/**
 * Jotai atoms for payments report state management
 * Manages report data, loading states, and pagination
 */

import { atom } from 'jotai';

// Report data from API - fields ordered to match UI table display
export interface PaymentReconciliationReportItem {
	// Display fields (in UI table order)
	customer: string;
	orderNumber: number | null;
	transferDate: string; // timestamp as string
	paidAt: string | null; // timestamp as string, only present for paid transfers
	transferAmount: string;
	processingFees: string; // Stripe fees
	ekhoFee: string;
	transferPlatform: string;
	receiptType: string;
	uid: string; // Vehicle ID
	transferId: string;
	recipientName: string;
	recipientId: string;
	receiptStatus: string;
	transferStatus: string;
	receiptId: string;
	placedOrderId: string;
	formattedVin: string;
}

// Payments report data atom
export const paymentReconciliationReportDataAtom = atom<PaymentReconciliationReportItem[] | null>(
	null,
);

// Loading state atom
export const isGeneratingPaymentReconciliationReportAtom = atom<boolean>(false);

// Pagination atoms
export const currentPageAtom = atom<number>(1);
export const itemsPerPageAtom = atom<number>(50);
